import * as React from 'react';
import {
  makeStyles,
  tokens,
  Button,
  Input,
  Field,
  MessageBar,
  MessageBarBody,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  field: {
    width: '100%',
  },
  button: {
    width: '100%',
    marginTop: tokens.spacingVerticalS,
  },
  backLink: {
    textAlign: 'center',
    marginTop: tokens.spacingVerticalM,
    fontSize: tokens.fontSizeBase300,
  },
  link: {
    color: tokens.colorBrandForeground1,
    textDecoration: 'none',
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  },
});

interface ResetPasswordFormProps {
  getFieldProps: (fieldName: string) => any;
  errors: Record<string, string>;
  onSubmit: (e: React.FormEvent) => void;
  loading: boolean;
  error: string | null;
  onBackToLogin: () => void;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({
  getFieldProps,
  errors,
  onSubmit,
  loading,
  error,
  onBackToLogin,
}) => {
  const styles = useStyles();

  return (
    <form onSubmit={onSubmit} className={styles.form}>
      {error && (
        <MessageBar intent="error">
          <MessageBarBody>{error}</MessageBarBody>
        </MessageBar>
      )}

      <Field
        label="Nova Senha"
        validationMessage={errors.password}
        validationState={errors.password ? 'error' : 'none'}
        className={styles.field}
      >
        <Input
          type="password"
          size="large"
          placeholder="Digite sua nova senha"
          {...getFieldProps('password')}
        />
      </Field>

      <Field
        label="Confirmar Nova Senha"
        validationMessage={errors.confirmPassword}
        validationState={errors.confirmPassword ? 'error' : 'none'}
        className={styles.field}
      >
        <Input
          type="password"
          size="large"
          placeholder="Confirme sua nova senha"
          {...getFieldProps('confirmPassword')}
        />
      </Field>

      <Button
        type="submit"
        appearance="primary"
        disabled={loading}
        className={styles.button}
      >
        {loading ? 'Redefinindo...' : 'Redefinir Senha'}
      </Button>

      <div className={styles.backLink}>
        <span
          className={styles.link}
          onClick={onBackToLogin}
        >
          Voltar ao Login
        </span>
      </div>
    </form>
  );
};

export default ResetPasswordForm;